module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAV1BMVEUAAAAt1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t1BDi9gAAAAHHRSTlMA8tsFNI/6r6NxQw/1yJ2WgyopGGxZ1Yx4UkkgC5oHQgAAAI9JREFUKM+lj9sKwyAQRHfVmIsajUl6nf//zooIgkJb2vO0Mwdcl/4gjszj1veKkWDV9lJg2p8ThGzEkqqsl0bMGCgxYP4s+qf65Xu/vP9uZesPNI6Pmg52poxXACcVTgChzBes0A/K3HUKrggLMwBeSalWIBhwEQBR0MjoW85VUPTCWuEjNaLylWh4J37hBTxYDdymZQdRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/name-hover.png
// module id = 455
// module chunks = 0 1 2 3 4 5 6 7